import {
  Layers,
  PaintRoller,
  Frame,
  Grid3x3,
  HardHat,
  Network,
} from "lucide-react";
import project1 from "@/assets/projects/project1.jpg";
import project2 from "@/assets/projects/project2.jpg";
import project3 from "@/assets/projects/project3.jpg";
import project4 from "@/assets/projects/project4.jpg";
import project5 from "@/assets/projects/project5.jpg";
import project6 from "@/assets/projects/project6.jpg";
import project7 from "@/assets/projects/project7.jpg";
import project8 from "@/assets/projects/project8.jpg";
import project9 from "@/assets/projects/project9.jpg";
import project10 from "@/assets/projects/project10.jpg";
import project12 from "@/assets/projects/project12.jpg";
import project13 from "@/assets/projects/project13.jpg";
import project14 from "@/assets/projects/project14.jpg";
import project15 from "@/assets/projects/project15.jpg";
import project16 from "@/assets/projects/project16.jpg";

export const COMPANY = {
  name: "LVM Drywall LLC",
  owner: "Luis Martinez",
  phone: "(980) 241-0890",
  phoneHref: "tel:+19802410890",
  email: "lvdrywall1414@gmail.com",
  emailHref: "mailto:lvdrywall1414@gmail.com",
  location: "6519 Deerwood Trl",
  slogan: "If we can't do it, we can certainly find the right person who can.",
};

export const SERVICES = [
  {
    icon: Layers,
    title: "Drywall Installation",
    desc: "Precise hanging of drywall for residential, commercial, and remodel projects of every size.",
  },
  {
    icon: PaintRoller,
    title: "Drywall Finishing",
    desc: "Taping, mudding, and smooth or textured finishes that leave walls ready for paint.",
  },
  {
    icon: Frame,
    title: "Metal Framing",
    desc: "Structural metal framing built straight, level, and to code every time.",
  },
  {
    icon: Grid3x3,
    title: "Acoustical Ceilings",
    desc: "Suspended grid and acoustical ceiling systems for offices, retail, and commercial spaces.",
  },
  {
    icon: HardHat,
    title: "General Construction",
    desc: "A wide range of construction-related support to keep your project moving forward.",
  },
  {
    icon: Network,
    title: "Trusted Network",
    desc: "Need something we don't perform? We connect you with skilled professionals who do.",
    accent: true,
  },
];

export const PROJECTS = [
  {
    id: "commercial-drywall",
    label: "Commercial Drywall Installation",
    blurb: "Large-scale drywall hung clean, plumb, and ready to finish.",
    cover: project1,
    images: [project1, project4, project5],
  },
  {
    id: "finishing-doors",
    label: "Finishing & Doors",
    blurb: "Smooth finished walls and installed door systems, ready for handover.",
    cover: project13,
    images: [project13, project2],
  },
  {
    id: "metal-framing",
    label: "Metal Stud Framing",
    blurb: "Precision metal stud framing built straight, level, and to code.",
    cover: project9,
    images: [project9, project8, project3, project12],
  },
  {
    id: "framing-insulation",
    label: "Framing & Insulation",
    blurb: "Wall and ceiling framing with insulation ready for board.",
    cover: project7,
    images: [project7, project14, project15],
  },
  {
    id: "mep-rough-in",
    label: "MEP Rough-In & Framing",
    blurb: "Framing coordinated around mechanical, electrical, and plumbing rough-in.",
    cover: project16,
    images: [project16, project10, project6],
  },
];

export const HERO_IMAGE = project1;

export const FRAMING_IMAGE =
  "https://images.unsplash.com/photo-1768321915258-d2b502e859e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
